import React, { memo, SVGProps } from 'react'

export const Warning = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.2867 5.29248C13.8096 4.46592 12.9542 3.97248 12 3.97248C11.0457 3.97248 10.1904 4.46592 9.71327 5.29248L3.49343 16.0685C3.01631 16.895 3.01631 17.8819 3.49343 18.7085C3.97055 19.535 4.82495 20.0285 5.77919 20.0285H18.2218C19.176 20.0285 20.0304 19.535 20.5075 18.7085C20.9846 17.8819 20.9846 16.895 20.5075 16.0685L14.2867 5.29248ZM19.2595 17.9875C19.0416 18.3638 18.6537 18.5875 18.2208 18.5875H5.77919C5.34623 18.5875 4.95839 18.3638 4.74047 17.9875C4.52351 17.6112 4.52351 17.1638 4.74047 16.7875L10.9603 6.01152C11.3952 5.26176 12.6048 5.26176 13.0397 6.01152L19.2595 16.7875C19.4765 17.1638 19.4765 17.6112 19.2595 17.9875Z"
      fill="currentColor"
    />
    <path
      d="M12 8.32224C11.6025 8.32224 11.28 8.6448 11.28 9.04224V13.6685C11.28 14.0659 11.6025 14.3885 12 14.3885C12.3974 14.3885 12.72 14.0659 12.72 13.6685V9.04224C12.72 8.6448 12.3974 8.32224 12 8.32224Z"
      fill="currentColor"
    />
    <path
      d="M11.4912 16.0416C11.3568 16.176 11.28 16.3584 11.28 16.5504C11.28 16.7318 11.3568 16.9248 11.4912 17.0582C11.6256 17.1936 11.8176 17.2704 12 17.2704C12.096 17.2704 12.1814 17.2502 12.2784 17.2118C12.3648 17.1734 12.4416 17.1254 12.5088 17.0582C12.6432 16.9238 12.72 16.7318 12.72 16.5504C12.72 16.3584 12.6432 16.175 12.5088 16.0416C12.24 15.7728 11.761 15.7728 11.4912 16.0416Z"
      fill="currentColor"
    />
  </svg>
))
